import { useEffect, useState } from 'react';
import { listPdvs } from '../services/inventory/pdvsApi';

/**
 * Catálogo COMPLETO de PDVs (`GET /pdvs`) — para selects de destino, onde o
 * alvo pode ser um PDV que o usuário não opera. Para o escopo do usuário
 * (origem de transferência, PDV de movimento), use `useUserPdvs`.
 *
 * O erro é devolvido ao chamador em vez de virar toast aqui: a tela decide se
 * mostra feedback (FC4 §B.8 — nada de catch silencioso, mas também nada de
 * toast dentro de hook de catálogo).
 *
 * @returns {{ pdvs: Array, isLoading: boolean, error: unknown }}
 */
export function useAllPdvs() {
   const [pdvs, setPdvs] = useState([]);
   const [isLoading, setIsLoading] = useState(true);
   const [error, setError] = useState(null);

   useEffect(() => {
      let active = true;

      async function loadPdvs() {
         setIsLoading(true);
         try {
            const list = await listPdvs();
            if (active) setPdvs(list);
         } catch (err) {
            if (active) {
               setError(err);
               setPdvs([]);
            }
         } finally {
            if (active) setIsLoading(false);
         }
      }

      loadPdvs();
      return () => {
         active = false;
      };
   }, []);

   return { pdvs, isLoading, error };
}

export default useAllPdvs;
